// Actiondan gelen datalar ile stateler güncellenecek
export const definationLoading = (state, payload) => {
  state.loading = payload
}

export const listCountries = (state, payload) => {
  state.countries = payload.data
}

export const listCities = (state, payload) => {
  state.cities = payload.data
}

export const listTowns = (state, payload) => {
  state.towns = payload.data
}

export const status = (state, payload) => {
  state.status = payload
}

export const listSubscription = (state, payload) => {
  state.subscriptions = payload.data
}

export const listAccountType = (state, payload) => {
  state.accountTypes = payload.data
}

export const listJobs = (state, payload) => {
  state.jobs = payload.data
}

export const listZoneTypes = (state, payload) => {
  state.zoneTypes = payload.data
}

export const listBrands = (state, payload) => {
  state.brands = payload.data
}

export const listModels = (state, payload) => {
  state.models = payload ? payload.data : [] 
}

export const listProtocols = (state, payload) => {
  state.protocols = payload.data
}

export const listTasks = (state, payload) => {
  state.tasks = payload.data
}

export const listSignalGroups = (state, payload) => {
  state.signalGroups = payload.data
}

export const listSignalTypes = (state, payload) => {
  state.signalTypes = payload.data
}

export const listQuickNotes = (state, payload) => {
  state.quickNotes = payload.data
}

export const listStockMovementTypes = (state, payload) => {
  state.stockMovementTypes = payload.data
}

export const listFaultSupportPieces = (state, payload) => {
  state.faultSupportPieces = payload.data
}

export const listFaultSupportResults = (state, payload) => {
  state.faultSupportResults = payload.data ? payload.data : []
}

export const listImportantNumbers = (state, payload) => {
  state.importantNumbers = payload.data
}

export const listVacations = (state, payload) => {
  state.vacations = payload.data
}

export const listVacationJobs = (state, payload) => {
  state.vacationJobs = payload.data
}

export const listVacation = (state, payload) => {
  state.vacation = payload.data
}

export const listEvaluationResults = (state, payload) => {
  state.evaluationResults = payload.data
}

export const listEventCodes = (state, payload) => {
  state.eventCodes = payload.data
  state.eventCodesPageInfo = payload.list_info
}

export const listProducts = (state, payload) => {
  if(payload && payload.data){
      state.products = payload.data
      state.productsPageInfo = payload.list_info
  } else {
      state.products = []
  }
}

export const setProductStatus = (state, payload) => {
  if(payload.data){
    state.status = payload.data ? payload.data : payload
  }
}

export const listSystemModules = (state, payload) => {
  state.systemModules = payload.data
}

export const listMenuTitles = (state, payload) => {
  state.systemMenus = payload.data
}

export const listCustomFields = (state, payload) => {
  state.customFields = payload.data
}

export const listForms = (state, payload) => {
  state.forms = payload.data
}

export const listFormsCustomFields = (state, payload) => {
  state.formCustomFields = payload.data
}

export const listTicketStatus = (state, payload) => {
  state.ticketStatus = payload.data
}

export const listReceivers = (state, payload) => {
  if(payload.data)
    state.receivers = payload.data
  else state.receivers = []
}

export const receiverDetail = (state, payload) => {
  if(payload.data)
    state.receiverDetail = payload.data
  else state.receiverDetail = {}
  
}

export const listRecProtocols = (state, payload) => {
  if(payload.data)
    state.receiverProtocols = payload.data
  else state.receiverProtocols = []
}

export const listProtocolFormats = (state, payload) => {
  if(payload.data)
    state.formats = payload.data
  else state.formats = []
}

export const getDeviceType = (state, payload) => {
  if(payload.data)
    state.deviceTypes = payload.data
  else state.deviceTypes = []
}
export const constants = (state, payload) => {
  if(payload.data)
    state.constants = payload.data
  else state.constants = []
}



// WEBPACK FOOTER //
// ./src/store/modules/Defination/Mutaions.js